import { API_CONFIG, API_ENDPOINTS } from '../config/api';
import { UserWithProfile, ProfileUpdateData } from '../types';
import { getAccessToken } from '../utils/authStorage';

class ProfileService {
  private async request<T>(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<T> {
    const url = `${API_CONFIG.BASE_URL}${endpoint}`;
    
    const defaultHeaders: HeadersInit = {
      'Content-Type': 'application/json',
    };

    const token = getAccessToken();
    if (token) {
      defaultHeaders.Authorization = `Bearer ${token}`;
    }

    const config: RequestInit = {
      ...options,
      headers: {
        ...defaultHeaders,
        ...options.headers,
      },
    };

    try {
      const response = await fetch(url, config);

      if (!response.ok) {
        let errorData;
        try {
          errorData = await response.json();
        } catch {
          errorData = { detail: `HTTP ${response.status}: ${response.statusText}` };
        }

        const errorMsg = errorData.detail || errorData.message || errorData.error || `HTTP ${response.status}`;
        throw new Error(Array.isArray(errorMsg) ? errorMsg.join(', ') : String(errorMsg));
      }

      const data = await response.json();
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error('Erro de rede ao conectar com o servidor');
    }
  }

  /**
   * Get current user profile with all details
   */
  async getProfile(): Promise<UserWithProfile> {
    return this.request<UserWithProfile>(API_ENDPOINTS.USER_PROFILE_DETAIL);
  }

  /**
   * Update user profile (supports both User and UserProfile fields)
   */
  async updateProfile(data: ProfileUpdateData): Promise<UserWithProfile> {
    return this.request<UserWithProfile>(API_ENDPOINTS.USER_PROFILE_UPDATE, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }
}

export const profileService = new ProfileService();

